import prescriptionDelete from "@custom/rtk-apis/patients/prescriptionDelete";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const prescriptionDeleteSlice = createSlice({
  name: "prescriptionDeleteSlice",
  initialState,
  reducers: {
    closePrescriptionModal (state:any) { state.status = ""; },
    reset: (state) => {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(prescriptionDelete.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(prescriptionDelete.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(prescriptionDelete.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.status = "FAILED";
        state.result = payload;
        state.loading = false;
      });
  },
});

export default prescriptionDeleteSlice.reducer;
export const { closePrescriptionModal, reset } = prescriptionDeleteSlice.actions;
